module.exports = require("./pt-GQ.d.ts");